/**
 * Fills the article's uid into the corresponding field in the product enquiry form.
 *
 * This UID is resolved to a complete article information set via a data processor on the server
 */
export function fillArticleNumberField(event: MouseEvent): void {
    const button: HTMLElement = <HTMLElement>event.relatedTarget;

    if (!button) {
        return;
    }

    const articleRow: HTMLTableRowElement | null = findContainingArticleRow(button);

    // since the form might be opened twice w/o page reload, we cannot remove the article number row for the "normal"
    // contact button (we might need it later)
    toggleArticleNumberRow(articleRow !== null);

    if (articleRow) {
        fillVisibleArticleNumberField(button);
    }
}

function findContainingArticleRow(button: HTMLElement): HTMLTableRowElement | null {
    return button.closest('tr');
}

function fillVisibleArticleNumberField(button: HTMLElement): void {
    const articleNumberField: HTMLInputElement | null = document.querySelector('#powermail_field_artikelnummer');

    if (articleNumberField === null) {
        console.warn('Could not find article number field in enquiry form');
        return;
    }

    const articleNumber: string | null = button.closest('tr')?.querySelector('th')?.innerText ?? null;
    if (articleNumber === null) {
        console.warn('Could not find article number in article row');
    }

    if (!(articleNumberField instanceof HTMLInputElement)) {
        console.warn('Article number field is not an input element');
    }

    // make field hidden
    articleNumberField.type = 'hidden';
    articleNumberField.value = articleNumber ?? '';

    const parentElement: HTMLElement | null = articleNumberField.parentElement;
    if (parentElement && articleNumber) {
        parentElement.innerText = articleNumber;

        // innerText resets the whole content, including other elements, so we must re-add it
        parentElement.appendChild(articleNumberField);
    }
}

function toggleArticleNumberRow(visible: boolean): void {
    const fieldRow: HTMLElement | null = document.querySelector('.powermail_fieldwrap_artikelnummer') ?? null;

    if (!fieldRow) {
        return;
    }

    const style: CSSStyleDeclaration | null = fieldRow.style ?? null;
    if (style) {
        if (visible) {
            style.display = '';
        } else {
            style.display = 'none';
        }
    }
}
